import type { IconSvgObject } from './types';

const DeleteRowIcon: IconSvgObject = [
  ["path", { d: "M18 21.1868C18.8888 20.9852 19.5638 20.6537 20.1088 20.1088C21.5 18.7175 21.5 16.4783 21.5 12C21.5 7.52166 21.5 5.28249 20.1088 3.89124C18.7175 2.5 16.4783 2.5 12 2.5C7.52166 2.5 5.28249 2.5 3.89124 3.89124C2.5 5.28249 2.5 7.52166 2.5 12C2.5 16.4783 2.5 18.7175 3.89124 20.1088C4.4362 20.6537 5.11125 20.9852 6.00001 21.1868", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21.5L12 18.5M12 18.5L15 15.5M12 18.5L9 15.5M12 18.5L15 21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 9L21.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 2.5L8.5 9M15.5 2.5L15.5 9", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default DeleteRowIcon;
